/**
 * Returns whether v matches the BingMapsAuthenticationResultCode type
 * @param v
 */
export function isBingMapsAuthenticationResultCode(v) {
    if (typeof v !== "string")
        return false;
    switch (v) {
        case "ValidCredentials" /* BingMapsAuthenticationResultCode.ValidCredentials */:
        case "InvalidCredentials" /* BingMapsAuthenticationResultCode.InvalidCredentials */:
        case "CredentialsExpired" /* BingMapsAuthenticationResultCode.CredentialsExpired */:
        case "NotAuthorized" /* BingMapsAuthenticationResultCode.NotAuthorized */:
        case "NoCredentials" /* BingMapsAuthenticationResultCode.NoCredentials */:
        case "None" /* BingMapsAuthenticationResultCode.None */:
            return true;
        default:
            return false;
    }
}
